import { useQuery } from "react-query";
import { QueryReturnType } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

interface IProps {
  id: any;
}

export const useGetKeyDetails = ({ id }: IProps): QueryReturnType<any> => {
  return useQuery<never, never, any>([ENDPOINTS.GET_KEY_DETAILS, { id: id }], {
    enabled: !!id,
    retry: false,
    refetchOnWindowFocus: false,
    notifyOnChangeProps: [
      "data",
      "error",
      "refetch",
      "isRefetching",
      "isSuccess",
      "isLoading",
    ],
  });
};
